import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Locale } from "date-fns";
import { enUS, es, ptBR } from "date-fns/locale";

const locales = {
  en: enUS,
  es,
  pt: ptBR,
};

export default function useDateFnsCurrentLocale() {
  const { i18n } = useTranslation();
  const currentLocale = useMemo<Locale>(() => {
    return locales[i18n.languages[0]];
  }, [i18n.languages]);
  return { currentLocale };
}
